import { render } from "./Afastamento.vue?vue&type=template&id=07026ad0"
import script from "./Afastamento.vue?vue&type=script&lang=js"
export * from "./Afastamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__